// Companies are now DB-backed. Use loadCompanies() to refresh and
// getCompanyFromCache(id) for synchronous access in print/render.
import axios from 'axios';
const API_URL = process.env.REACT_APP_BACKEND_URL;

let _cache = [];

export const loadCompanies = async () => {
  try {
    const r = await axios.get(`${API_URL}/api/companies`, { withCredentials: true });
    _cache = r.data || [];
  } catch (e) {
    console.error('loadCompanies failed', e);
  }
  return _cache;
};

export const getCompaniesCache = () => _cache;

export const getCompanyFromCache = (id) =>
  _cache.find((c) => c.id === id) || _cache[0] || {
    id: 'fallback', name: 'Company', short: 'CO', gst_enabled: false,
    bank: {}, accent: '#1D9E75',
  };

// Build a UPI deep-link: upi://pay?pa=...&pn=...&am=...&cu=INR&tn=...
export const buildUpiLink = (vpa, name, amount, note) => {
  const params = new URLSearchParams({
    pa: vpa || '',
    pn: name || '',
    am: amount ? String(amount) : '',
    cu: 'INR',
    tn: note || '',
  });
  return `upi://pay?${params.toString()}`;
};
